<template>
  <div class="error-feedback">
    <FontAwesomeIcon
      :icon="['fak', 'information-circle']"
      class="text-danger-text"
    />
    <p> {{ message }} </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const { field } = defineProps<{
  field: 'partnerField' | 'crmField';
}>();
const message = computed(() =>
  field === 'crmField'
    ? 'Field not found in CRM'
    : 'Partner no longer sharing field',
);
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";
.error-feedback {
  @apply text-danger-text-strong flex items-center gap-8 absolute mt-8 text-sm;
}
</style>
